module.exports = __webpack_public_path__ + "img/img_03.c0b9a827.webp";